import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white pt-12 pb-8 mt-auto">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <SafeIcon icon={FiIcons.FiShield} className="text-2xl text-accent" />
              <div className="flex flex-col">
                <span className="text-lg font-bold">Moringa</span>
                <span className="text-[10px] uppercase tracking-widest text-gray-400">Safety Report</span>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Dedicated to providing accurate, timely, and independent safety information about moringa supplements to protect consumers and promote transparency.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/alerts" className="hover:text-white transition-colors">Safety Alerts</Link></li>
              <li><Link to="/products" className="hover:text-white transition-colors">Product Database</Link></li>
              <li><Link to="/resources" className="hover:text-white transition-colors">Educational Resources</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4">Legal & Policy</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="#" className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="#" className="hover:text-white transition-colors">Terms of Service</Link></li>
              <li><Link to="#" className="hover:text-white transition-colors">Editorial Standards</Link></li>
              <li><Link to="#" className="hover:text-white transition-colors">Disclaimer</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4">Contact</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li className="flex items-center gap-2">
                <SafeIcon icon={FiIcons.FiMail} /> report@moringasafety.com
              </li>
              <li className="flex items-center gap-2">
                <SafeIcon icon={FiIcons.FiPhone} /> 1-800-SAFETY-1
              </li>
              <li className="mt-4">
                <button className="bg-primary hover:bg-primary-light text-white px-4 py-2 rounded text-xs font-bold uppercase tracking-wide transition-colors w-full">
                  Report Adverse Event
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500">
          <p>© 2024 Moringa Safety Report. All rights reserved.</p>
          <p className="mt-2 md:mt-0">Not affiliated with any supplement manufacturer.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;